import * as React from "react";
import { createRoot } from "react-dom/client";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { HashRouter, Navigate, Route, Routes } from "react-router-dom";
import { isLoggedIn } from "../shared/authService";
import AuthPage from "../auth/AuthPage";
import LegalReviewerApp from "../reviewer/ReviewerApp";
import "../reviewer/styles/base.css";
import "../reviewer/styles/header.css";
import "../reviewer/styles/summary.css";
import "../reviewer/styles/chat.css";
import "../reviewer/styles/suggestions.css";
import "../reviewer/styles/input.css";
import "../reviewer/styles/toast.css";

/* global document, Office, module, require, HTMLElement */

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

const ensureHistoryShims = () => {
  const history = window.history as any;
  if (typeof history.replaceState !== "function") {
    history.replaceState = (_state: any, _title: string, url?: string | null) => {
      if (typeof url === "string") {
        window.location.hash = url.includes("#") ? url.split("#")[1] ?? "" : url;
      }
    };
  }
  if (typeof history.pushState !== "function") {
    history.pushState = (_state: any, _title: string, url?: string | null) => {
      if (typeof url === "string") {
        window.location.hash = url.includes("#") ? url.split("#")[1] ?? "" : url;
      }
    };
  }
};

const RequireAuth: React.FC<{ children: React.ReactElement }> = ({ children }) =>
  !isLoggedIn() ? <Navigate to="/auth" replace /> : children;

const AppRoutes = () => (
  <Routes>
    <Route path="/auth" element={<AuthPage />} />
    <Route
      path="/reviewer"
      element={
        <RequireAuth>
          <LegalReviewerApp />
        </RequireAuth>
      }
    />
    <Route path="/" element={<Navigate to="/reviewer" replace />} />
    <Route path="*" element={<Navigate to="/auth" replace />} />
  </Routes>
);

Office.onReady(() => {
  ensureHistoryShims();
  root?.render(
    <FluentProvider theme={webLightTheme} style={{ minHeight: "100vh" }}>
      <HashRouter>
        <AppRoutes />
      </HashRouter>
    </FluentProvider>
  );
});

if ((module as any).hot) {
  (module as any).hot.accept("./index", () => {
    root?.render(
      <FluentProvider theme={webLightTheme}>
        <HashRouter>
          <AppRoutes />
        </HashRouter>
      </FluentProvider>
    );
  });
}
